export default __webpack_public_path__ + "static/media/dtftransfers-logo_white.ae356166.png";